export function type(obj) {
    const toString = Object.prototype.toString
    const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
    }

    return map[toString.call(obj)]
}

// id、pid结构转层级签套
// 前提: id唯一、没有签套结构
export function listToTree(list, {
    id: _id = "id",
    pId: _pId = "pId",
    rootId: _rootId = "",
    level: _level = "level",
    isEnd: _isEnd = "isEnd",
    children: _children = "children",
    copy = true,
    done = function(tree, map, list) {}
} = {}) {
    var map = {},
        tree

    // copy
    if (copy) {
        list = list.map(t => Object.assign({}, t))
    }

    // 建立索引
    list.forEach(t => {
        map[t[_id]] = t
        t[_isEnd] = true
        t[_children] = []
    })

    // 建立父子关系
    list.forEach(t => {
        var parent = map[t[_pId]]

        t.isTop = !parent

        parent && (parent[_children] ? parent[_children].push(t) : parent[_children] = [t], parent[_isEnd] = false)
    })

    // 建立level
    function setLevel(node, level) {
        node[_level] = level

        if (node[_children]) {
            node[_children].forEach(t => setLevel(t, level + 1))
        }
    }

    list.filter(t => t.isTop).forEach(t => setLevel(t, 1))

    tree = list.filter(t => {
        if (_rootId) {
            return t[_pId] == _rootId
        } else {
            return t.isTop
        }
    })

    // 转换完成后回调
    done(tree, map, list)

    // 返回tree
    return tree
}

var proto = Object.prototype;
var gpo = Object.getPrototypeOf;

// 是否字面量对象
export function isPojo(obj) {
    if (obj === null || typeof obj !== "object") {
        return false;
    }
    return gpo(obj) === proto;
}

const _i18nMerge = (source, target) => {
    Object.keys(target).forEach(key => {
        // 是对象
        if (isPojo(target[key])) {
            if (!isPojo(source[key])) {
                source[key] = {}
            }

            _i18nMerge(source[key], target[key])
        } else {
            source[key] = target[key]
        }
    })

    return source
}

// 多语言文件合并
export function i18nMerge(source) {
    var targets = Array.prototype.slice.call(arguments, 1)

    return targets.reduce((acc, t) => _i18nMerge(acc, t), source)
}

// 深度遍历
export function deepTraverse(root, callback, options = {}) {
    var { children = "children" } = options
    var isContinue = true // 控制遍历是否继续执行 

    function iterate(node, parent, options) {
        isContinue = callback(node, parent, options)

        // 默认继续
        if (typeof isContinue == "undefined") {
            isContinue = true
        }

        if (isContinue && node[children]) {
            node[children].every(n => iterate(n, node, options))
        }

        return isContinue
    }

    iterate(root, null, options)
}

export function getMenuByRouter(list) {
    let res = []

    list.forEach(item => {
        if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
            let obj = {
                icon: (item.meta && item.meta.icon) || '',
                name: item.meta.targetName,
                meta: item.meta
            }

            // 子级菜单
            if ((hasChild(item) || (item.meta && item.meta.showAlways))) {
                obj.children = getMenuByRouter(item.children)
            }

            // 支持静态超链接
            if (item.meta && item.meta.href) obj.href = item.meta.href

            res.push(obj)
        }
    })

    return res
}

export function hasChild(item) {
    return item.children && item.children.length !== 0
}

// 推平菜单路由配置
export const flatMenuConfig = (menuConfig) => {
    var map = {}

    function flat(config) {
        Object.keys(config).forEach(uri => {
            var c = config[uri]

            if (map[uri]) {
                throw new Error("发现重复的路由，uri=" + uri)
            }

            map[uri] = c

            if (c.children) {
                flat(c.children)
            }
        })
    }

    flat(menuConfig)

    return map
}

// 菜单路由别名 -> uri 映射
export const transMenuAliasToUri = (menuConfig) => {
    var moduleAlias = {}

    Object.keys(menuConfig)
        .forEach(uri => {
            var r = menuConfig[uri]

            if (r.name) {
                moduleAlias[r.name] = uri
            }
        })

    return moduleAlias
}